import { useState } from "react";

// Karta doradcy przy formularzach — twarz i konkretna obietnica zamiast anonimowej prośby o telefon.
// Zdjęcie leży w public/media/; gdy go brakuje, pokazujemy inicjały, żeby karta nigdy nie była "zepsuta".
const PHOTO_SRC = "/media/martyna-mostek.jpg";

export function AdvisorCard({ variant = "full" }: { variant?: "full" | "compact" }) {
  const [photoOk, setPhotoOk] = useState(true);
  const size = variant === "compact" ? 46 : 60;

  return (
    <div className={`advisor-card advisor-card-${variant}`}>
      {photoOk ? (
        <img
          src={PHOTO_SRC}
          alt="Martyna Mostek — doradca ubezpieczeniowy"
          width={size}
          height={size}
          loading="lazy"
          onError={() => setPhotoOk(false)}
        />
      ) : (
        <span className="advisor-avatar-fallback" aria-hidden="true">
          MM
        </span>
      )}
      <div className="advisor-card-text">
        <strong>Martyna Mostek</strong>
        <span>doradca ubezpieczeniowy</span>
        <p>Oddzwaniam zwykle w 30 minut (pn–pt 9–18).</p>
      </div>
    </div>
  );
}
